<template>
  <div class="lesson py-10 relative">
    <div class="z-20 absolute w-full">
      <img src="../assets/images/lesson_web_title.png" class="w-[60%] max-w-[700px] mx-auto mb-10 hidden md:block">
      <img src="../assets/images/lesson_web_title1.png"  class="w-[50%] max-w-[600px]  mx-auto mb-10  hidden md:block">
      <div class="w-[60%] max-w-[700px] mx-auto mb-20 relative hidden md:block">
        <img src="../assets/images/lesson_web_title2.png"  class="w-full">
        <img src="../assets/images/lesson_mb_morebtn.png"  class="w-[50%] absolute bottom-[-13.5%] left-[25%] cursor-pointer" @click="openMore(0)">
      </div>
      <div class="w-[60%] max-w-[700px] mx-auto mb-20 relative hidden md:block">
        <img src="../assets/images/lesson_web_title3.png"  class="w-full">
        <img src="../assets/images/lesson_mb_morebtn.png"  class="w-[50%] absolute bottom-[-9.5%] left-[25%]  cursor-pointer" @click="openMore(1)">
      </div>
      <img src="../assets/images/lesson_mb_title1.png" class="w-[90%] mx-auto mb-20 md:hidden">
      <div class="w-[90%] mx-auto mb-20 relative md:hidden">
        <img src="../assets/images/lesson_mb_title2.png"  class="w-full">
        <img src="../assets/images/lesson_mb_morebtn.png"  class="w-[90%] mx-auto absolute bottom-[-10.5%] left-[10%]  cursor-pointer" @click="openMore(0)">
      </div>
      <div class="w-[90%] mx-auto mb-20 relative md:hidden">
        <img src="../assets/images/lesson_mb_title3.png"  class="w-full">
        <img src="../assets/images/lesson_mb_morebtn.png"  class="w-[90%] mx-auto absolute bottom-[-9.5%] left-[10%] cursor-pointer" @click="openMore(1)">
      </div>
    </div>
    <div class="z-10 fixed top-0 w-full">
      <img src="../assets/images/lesson_bg_shine.png"  class="w-full max-w-[700px] mx-auto scale-125">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import axios from 'axios'
// import CryptoJS from 'crypto-js'
// import axios from 'axios'
// import liff from '@line/liff'
// import api from '@/service/api'
// const apiBaseUrl = process.env.VUE_APP_API_BASE
export default {
  name: 'LessonView',
  components: {
    // HelloWorld
  },
  data () {
    return {
    }
  },
  created () {
  },
  async mounted () {
  },
  methods: {
    openMore (num) {
      this.$router.push({ name: 'lessoninfo', query: { source: num } })
    }
  }
}
</script>
<style lang="scss" scoped>
.lesson{
  background-image: radial-gradient(circle at 50% 40%, #1c5ee7, #1342ac 34%, #08082d 71%);
  height: 100vh;
  overflow-y: scroll;
}
</style>
